import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminConfig } from '@features/referentiel/config/admin.config';
import { PortalStatus } from '@features/referentiel/models/portal-status.model';
import { AppSourceEnum } from 'pu-core-library';

@Injectable({
  providedIn: 'root',
})
export class PortalStatusService {
  constructor(private httpClient: HttpClient) {}

  getPortalStatuses(): Observable<PortalStatus[]> {
    return this.httpClient.get<PortalStatus[]>(
      `${AdminConfig.getPortalStatusesUrl}?source-code=${AppSourceEnum.POF}`,
    );
  }
}
